<div class="lookup-user-legacy-data-wrap">
  <!-- Degree Information -->
  <div class="row ml-0 mr-0">
    <div class="panel-blue w-100">
      <div
        class="header d-flex justify-content-between align-items-center"
        (click)="toggleDegreePanel()"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="showDegreePanel"
        aria-controls="lookupLegacyDegreePanel">
        <span class="panel-title mb-0">Degree Information</span>
        <button type="button" class="toggle-panel position-static" *ngIf="showDegreePanel" (click)="toggleDegreePanel(); $event.stopPropagation()" aria-label="Collapse">
          <i class="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
        <button type="button" class="toggle-panel position-static" *ngIf="!showDegreePanel" (click)="toggleDegreePanel(); $event.stopPropagation()" aria-label="Expand">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </button>
      </div>
      <div class="panel-body p-0" id="lookupLegacyDegreePanel" *ngIf="showDegreePanel">
        <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2" (click)="$event.stopPropagation()">
          <div class="lookup-personal-grid-actions-wrap d-flex align-items-center">
            <app-grid-actions
              [actions]="degreeGridActions"
              [showColumnChooser]="showDegreeColumnChooser"
              [allColumns]="degreeAllColumns"
              [visibleColumns]="degreeVisibleColumns"
              (exportClick)="exportLegacyDegree()"
              (columnChooserToggle)="toggleDegreeColumnChooser()"
              (columnToggle)="onDegreeColumnToggle($event)"
              (columnChooserClose)="closeDegreeColumnChooser()">
            </app-grid-actions>
          </div>
        </div>
        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <app-data-grid #degreeGrid [config]="degreeGridConfig" [activeTab]="'default'" [wordWrapEnabled]="false"></app-data-grid>
        </div>
      </div>
    </div>
  </div>

  <!-- Verifiable Teaching Experience -->
  <div class="row ml-0 mr-0">
    <div class="panel-blue w-100">
      <div
        class="header d-flex justify-content-between align-items-center"
        (click)="toggleTeachingPanel()"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="showTeachingPanel"
        aria-controls="lookupLegacyTeachingPanel">
        <span class="panel-title mb-0">Verifiable Teaching Experience</span>
        <button type="button" class="toggle-panel position-static" *ngIf="showTeachingPanel" (click)="toggleTeachingPanel(); $event.stopPropagation()" aria-label="Collapse">
          <i class="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
        <button type="button" class="toggle-panel position-static" *ngIf="!showTeachingPanel" (click)="toggleTeachingPanel(); $event.stopPropagation()" aria-label="Expand">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </button>
      </div>
      <div class="panel-body p-0" id="lookupLegacyTeachingPanel" *ngIf="showTeachingPanel">
        <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2" (click)="$event.stopPropagation()">
          <div class="lookup-personal-grid-actions-wrap d-flex align-items-center">
            <app-grid-actions
              [actions]="teachingGridActions"
              [showColumnChooser]="showTeachingColumnChooser"
              [allColumns]="teachingAllColumns"
              [visibleColumns]="teachingVisibleColumns"
              (exportClick)="exportLegacyTeaching()"
              (columnChooserToggle)="toggleTeachingColumnChooser()"
              (columnToggle)="onTeachingColumnToggle($event)"
              (columnChooserClose)="closeTeachingColumnChooser()">
            </app-grid-actions>
          </div>
        </div>
        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <app-data-grid #teachingGrid [config]="teachingGridConfig" [activeTab]="'default'" [wordWrapEnabled]="false"></app-data-grid>
        </div>
      </div>
    </div>
  </div>

  <!-- Testing -->
  <div class="row ml-0 mr-0">
    <div class="panel-blue w-100">
      <div
        class="header d-flex justify-content-between align-items-center"
        (click)="toggleTestingPanel()"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="showTestingPanel"
        aria-controls="lookupLegacyTestingPanel">
        <span class="panel-title mb-0">Testing</span>
        <button type="button" class="toggle-panel position-static" *ngIf="showTestingPanel" (click)="toggleTestingPanel(); $event.stopPropagation()" aria-label="Collapse">
          <i class="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
        <button type="button" class="toggle-panel position-static" *ngIf="!showTestingPanel" (click)="toggleTestingPanel(); $event.stopPropagation()" aria-label="Expand">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </button>
      </div>
      <div class="panel-body p-0" id="lookupLegacyTestingPanel" *ngIf="showTestingPanel">
        <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2" (click)="$event.stopPropagation()">
          <div class="lookup-personal-grid-actions-wrap d-flex align-items-center">
            <app-grid-actions
              [actions]="testingGridActions"
              [showColumnChooser]="showTestingColumnChooser"
              [allColumns]="testingAllColumns"
              [visibleColumns]="testingVisibleColumns"
              (exportClick)="exportLegacyTesting()"
              (columnChooserToggle)="toggleTestingColumnChooser()"
              (columnToggle)="onTestingColumnToggle($event)"
              (columnChooserClose)="closeTestingColumnChooser()">
            </app-grid-actions>
          </div>
        </div>
        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <app-data-grid #testingGrid [config]="testingGridConfig" [activeTab]="'default'" [wordWrapEnabled]="false"></app-data-grid>
        </div>
      </div>
    </div>
  </div>

  <!-- Remarks -->
  <div class="row ml-0 mr-0">
    <div class="panel-blue w-100">
      <div
        class="header d-flex justify-content-between align-items-center"
        (click)="toggleRemarksPanel()"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="showRemarksPanel"
        aria-controls="lookupLegacyRemarksPanel">
        <span class="panel-title mb-0">Remarks</span>
        <button type="button" class="toggle-panel position-static" *ngIf="showRemarksPanel" (click)="toggleRemarksPanel(); $event.stopPropagation()" aria-label="Collapse">
          <i class="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
        <button type="button" class="toggle-panel position-static" *ngIf="!showRemarksPanel" (click)="toggleRemarksPanel(); $event.stopPropagation()" aria-label="Expand">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </button>
      </div>
      <div class="panel-body p-0" id="lookupLegacyRemarksPanel" *ngIf="showRemarksPanel">
        <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2" (click)="$event.stopPropagation()">
          <div class="lookup-personal-grid-actions-wrap d-flex align-items-center">
            <app-grid-actions
              [actions]="remarksGridActions"
              [showColumnChooser]="showRemarksColumnChooser"
              [allColumns]="remarksAllColumns"
              [visibleColumns]="remarksVisibleColumns"
              (exportClick)="exportLegacyRemarks()"
              (columnChooserToggle)="toggleRemarksColumnChooser()"
              (columnToggle)="onRemarksColumnToggle($event)"
              (columnChooserClose)="closeRemarksColumnChooser()">
            </app-grid-actions>
          </div>
        </div>
        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <app-data-grid #remarksGrid [config]="remarksGridConfig" [activeTab]="'default'" [wordWrapEnabled]="false"></app-data-grid>
        </div>
      </div>
    </div>
  </div>

  <!-- Documents -->
  <div class="row ml-0 mr-0">
    <div class="panel-blue w-100">
      <div
        class="header d-flex justify-content-between align-items-center"
        (click)="toggleDocumentsPanel()"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="showDocumentsPanel"
        aria-controls="lookupLegacyDocumentsPanel">
        <span class="panel-title mb-0">Documents</span>
        <button type="button" class="toggle-panel position-static" *ngIf="showDocumentsPanel" (click)="toggleDocumentsPanel(); $event.stopPropagation()" aria-label="Collapse">
          <i class="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
        <button type="button" class="toggle-panel position-static" *ngIf="!showDocumentsPanel" (click)="toggleDocumentsPanel(); $event.stopPropagation()" aria-label="Expand">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </button>
      </div>
      <div class="panel-body p-0" id="lookupLegacyDocumentsPanel" *ngIf="showDocumentsPanel">
        <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2" (click)="$event.stopPropagation()">
          <div class="lookup-personal-grid-actions-wrap d-flex align-items-center">
            <app-grid-actions
              [actions]="documentsGridActions"
              [showColumnChooser]="showDocumentsColumnChooser"
              [allColumns]="documentsAllColumns"
              [visibleColumns]="documentsVisibleColumns"
              (exportClick)="exportLegacyDocuments()"
              (columnChooserToggle)="toggleDocumentsColumnChooser()"
              (columnToggle)="onDocumentsColumnToggle($event)"
              (columnChooserClose)="closeDocumentsColumnChooser()">
            </app-grid-actions>
          </div>
        </div>
        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <app-data-grid #documentsGrid [config]="documentsGridConfig" [activeTab]="'default'" [wordWrapEnabled]="false">
            <ng-template #actionsTemplate let-data>
              <div class="action-buttons-container" role="group" aria-label="Document actions">
                <button type="button" class="btn btn-link btn-sm p-0" (click)="onLegacyDocumentAction(data); $event.stopPropagation()">View</button>
              </div>
            </ng-template>
          </app-data-grid>
        </div>
      </div>
    </div>
  </div>
</div>
